const baseUrl = 'https://xo3f3b9z8j.execute-api.us-east-1.amazonaws.com/Prod/'; // TODO: This needs to be replaced

const showAlert = (cssClass, message) => {
  const html = `
    <div class="alert alert-${cssClass} alert-dismissible" role="alert">
        <strong>${message}</strong>
        <button class="close" type="button" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">×</span>
        </button>
    </div>`;

    if (document.querySelector('#alert')) {
      document.querySelector('#alert').innerHTML += html;
    }
};

const formToJSON = (elements) => [].reduce.call(elements, (data, element) => {
  data[element.name] = element.value;
  return data;
}, {});

const getUrlParameter = (name) => {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  const regex = new RegExp(`[\\?&]${name}=([^&#]*)`);
  const results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

export const addFormListener = (setSendingData, setDataSubmitted, setRegistrationError) => {
  const form = document.getElementsByClassName('form-signin')[0];

  const handleFormSubmit = (event) => {
    event.preventDefault();
  
    const postUrl = `${baseUrl}subscriber`;
    const regToken = getUrlParameter('x-amzn-marketplace-token');
    
    if (!regToken) {
      showAlert('danger',
      'Registration Token Missing. Please go to AWS Marketplace and follow the instructions to set up your account!');
    } else {
      const data = formToJSON(form.elements);
      data.regToken = regToken;
      
  
      const xhr = new XMLHttpRequest();
  
      xhr.open('POST', postUrl, true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.send(JSON.stringify(data));
      setSendingData(true);
      xhr.onreadystatechange = () => {
        if (xhr.readyState == XMLHttpRequest.DONE) {
          setSendingData(false);
          if (xhr.status === 400) {
            setRegistrationError(true);
          } else {
            showAlert('primary', xhr.responseText);
            setDataSubmitted(true);
            console.log(JSON.stringify(xhr.responseText));
          }
        }
      };
    }
  };
  
  if (form) {
    form.addEventListener('submit', handleFormSubmit);
  
    return () => form.removeEventListener('submit', handleFormSubmit);
  }

  return () => {};
};

export const onLoad = () => {
  const regToken = getUrlParameter('x-amzn-marketplace-token');
  if (!regToken) {
    showAlert('danger', 'Registration Token Missing. Please go to AWS Marketplace and follow the instructions to set up your account!');
  }
  
  if (!baseUrl) {
    showAlert('danger', 'Please update the baseUrl');
  }
}
